// src/components/QuickMenuTooltip.jsx
import { useState, useEffect } from 'react';
import { X, Sparkles } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const STORAGE_KEY = 'quickMenuTooltipDismissed';

export default function QuickMenuTooltip() {
  const { currentUser } = useAuth();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (!currentUser?.uid) return;

    // Verificar si el usuario ya desactivó el tooltip
    const dismissed = localStorage.getItem(`${STORAGE_KEY}_${currentUser.uid}`);
    if (dismissed === 'true') {
      setIsDismissed(true);
      setIsVisible(false);
      return;
    }

    // Mostrar después de un delay para que la página cargue
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, [currentUser]);

  const handleDismiss = () => {
    setIsVisible(false);
  };

  const handleDontShowAgain = () => {
    if (currentUser?.uid) {
      localStorage.setItem(`${STORAGE_KEY}_${currentUser.uid}`, 'true');
      setIsDismissed(true);
      setIsVisible(false);
    }
  };

  if (!isVisible || isDismissed) return null;

  return (
    <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-[60] animate-in slide-in-from-bottom-4 fade-in duration-500 pointer-events-auto">
      <div className="relative bg-slate-800 dark:bg-slate-900 rounded-2xl shadow-2xl p-4 max-w-[320px] mx-4">
        {/* Flecha apuntando hacia abajo (al botón) */}
        <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2">
          <div className="w-3 h-3 bg-slate-800 dark:bg-slate-900 rotate-45"></div>
        </div>

        {/* Botón cerrar - oculto pero funcional al tocar */}
        <button
          onClick={handleDismiss}
          className="absolute top-2 right-2 w-6 h-6 rounded-full hover:bg-slate-700 dark:hover:bg-slate-800 flex items-center justify-center transition-colors opacity-0 hover:opacity-100"
          aria-label="Cerrar"
        >
          <X className="h-4 w-4 text-slate-400" />
        </button>

        {/* Contenido simple y limpio */}
        <div className="text-white">
          <p className="text-sm leading-relaxed mb-2">
            Agendá rápido desde el botón <strong className="text-blue-400">"+"</strong>
          </p>
          <p className="text-sm leading-relaxed mb-3">
            Nuevo modal intuitivo para crear citas
          </p>
          
          {/* Checkbox oculto pero funcional */}
          <label className="flex items-center gap-2 cursor-pointer group w-full pt-2 border-t border-slate-700">
            <input
              type="checkbox"
              onChange={handleDontShowAgain}
              className="w-4 h-4 rounded border-slate-600 bg-slate-700 text-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-0 cursor-pointer"
            />
            <span className="text-xs text-slate-400 group-hover:text-slate-300 transition-colors">
              No volver a mostrar
            </span>
          </label>
        </div>
      </div>
    </div>
  );
}

